import { releaseNotesActions } from '@sv-support-sdk/store';
import { releaseNotesActions as releaseNotesActionsSlices } from '../slices/releaseNotes';

export default {
  ...releaseNotesActionsSlices,
  ...releaseNotesActions,
};
